/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'welcome';
const componentName = 'repeated-inputs';
const prefix = `${moduleName}.${componentName}`;

export const removeItemBtnLabel = `${prefix}.removeItemBtnLabel`;
export const addItemBtnLabel = `${prefix}.addItemBtnLabel`;
export const itemLabel = `${prefix}.itemLabel`;

export const ENGLISH = {
    [removeItemBtnLabel]: 'Remove {0}',
    [addItemBtnLabel]: '+ Add {0}',
    [itemLabel]: 'Item',
};
